if (!customElements.get('sticky-video-controller')) {
  customElements.define('sticky-video-controller', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('sticky-images-and-text');
      this.videos = [...section.querySelectorAll('[data-sticky-video]')];
      this.visible = new Set();
      this.events = new AbortController();
      this.sync = () => {
        this.videos.forEach(video => {
          const active = video.closest('[data-sticky-image]').classList.contains('is-active');
          if (!document.hidden && active && this.visible.has(video)) {
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };
      this.visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.visible.add(entry.target);
          else this.visible.delete(entry.target);
        });
        this.sync();
      });
      this.slides = new MutationObserver(this.sync);
      this.videos.forEach(video => {
        this.visibility.observe(video);
        this.slides.observe(video.closest('[data-sticky-image]'), { attributes: true, attributeFilter: ['class'] });
      });
      document.addEventListener('visibilitychange', this.sync, { signal: this.events.signal });
    }

    disconnectedCallback() {
      this.visibility?.disconnect();
      this.slides?.disconnect();
      this.events?.abort();
      this.videos?.forEach(video => video.pause());
      this.visible?.clear();
    }
  });
}
